import React from 'react';
import  ReactDOM  from 'react-dom';

import App from './App';

// react application inside this compononent App
ReactDOM.render(<App />, document.getElementById('root'))
